import { COUNTRY_NETWORK_GET_URL } from '@1po/1po-bff-fe-spec/generated/backoffice/BackofficeURLs';
import {
  BACKOFFICE_GET_COUNTRY_NETWORK_RESPONSE,
  BACKOFFICE_UPDATE_COUNTRY_RETURN_FEATURE_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { RequestResponseMappingManager } from 'domains/webSockets/WebSocket.requestsResponseMapping';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

// New separate URLs for RD and MKTP
const COUNTRY_NETWORK_UPDATE_RD_RETURN_URL = '/backoffice/country-network/rd-return/update';
const COUNTRY_NETWORK_UPDATE_MKTP_RETURN_URL = '/backoffice/country-network/mktp-return/update';

// Register request-response mappings
RequestResponseMappingManager.addMapping(COUNTRY_NETWORK_GET_URL, BACKOFFICE_GET_COUNTRY_NETWORK_RESPONSE);
RequestResponseMappingManager.addMapping(
  COUNTRY_NETWORK_UPDATE_RD_RETURN_URL,
  BACKOFFICE_UPDATE_COUNTRY_RETURN_FEATURE_RESPONSE,
);
RequestResponseMappingManager.addMapping(
  COUNTRY_NETWORK_UPDATE_MKTP_RETURN_URL,
  BACKOFFICE_UPDATE_COUNTRY_RETURN_FEATURE_RESPONSE,
);

export function sendGetCountryNetwork(): WebSocketAction {
  return wsSendAction(COUNTRY_NETWORK_GET_URL, null);
}

export function sendUpdateRdReturnFeature(isEnabled: boolean): WebSocketAction {
  return wsSendAction(COUNTRY_NETWORK_UPDATE_RD_RETURN_URL, { isEnabled });
}

export function sendUpdateMktpReturnFeature(isEnabled: boolean): WebSocketAction {
  return wsSendAction(COUNTRY_NETWORK_UPDATE_MKTP_RETURN_URL, { isEnabled });
}
